export default class ProgressEvent {
  constructor(position, duration, muted) {
    this.position = Math.round(position);
    this.duration = Math.round(duration);
    this.remaining = this.duration - this.position;
    this.muted = muted;
  }

  percentage() {
    return Math.round(((this.duration - this.remaining) / this.duration) * 100);
  }

  toSeconds() {
    return {
      position: this.position / 1000,
      duration: this.duration / 1000,
      remaining: this.remaining / 1000
    };
  }

  formatedTimes() {
    return {
      position: `0${Math.round(this.position / 1000 / 60).toString().slice(-2)}:0${Math.round(this.position / 1000).toString().slice(-2)}`,
      duration: `0${Math.round(this.duration / 1000 / 60).toString().slice(-2)}:0${Math.round(this.duration / 1000).toString().slice(-2)}`,
      remaining: `-0${Math.round(this.remaining / 1000 / 60).toString().slice(-2)}:0${Math.round(this.remaining / 1000).toString().slice(-2)}`,
    };
  }
}
